"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralRewardStatusEnum = void 0;
var ReferralRewardStatusEnum;
(function (ReferralRewardStatusEnum) {
    ReferralRewardStatusEnum["Pending"] = "pending";
    ReferralRewardStatusEnum["Available"] = "available";
    ReferralRewardStatusEnum["Canceled"] = "canceled";
    ReferralRewardStatusEnum["Consumed"] = "consumed";
})(ReferralRewardStatusEnum = exports.ReferralRewardStatusEnum || (exports.ReferralRewardStatusEnum = {}));
//# sourceMappingURL=referral-reward-status-enum.js.map